import {getRecordPath, getRecordUrlId} from 'shared/utils/data-service-utils';

// @formatter:off
/**
 * @ngdoc filter
 * @name kpRecordDetailPath
 * @module portaro.filters
 * @kind function
 *
 * @param {{id, type}} record Record object. It must contain `id`
 *
 * @return {string} URL of record
 *
 * @description
 * Filter returns full URL to given record.
 *
 * @example
 * <example module="kpRecordDetailPathExample" name="kpRecordDetailPathExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-init="record = {id: 'f124b88d-5618-4438-a2f1-5278dc21f7af'}">
            <div>
                <label for="input">ID: </label>
                <input id="input" type="text" ng-model="record.id">
            </div>
            <div>
                Result: {{record | kpRecordDetailPath}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('kpRecordDetailPathExample', ['portaro.filters'])
            .constant('CONTEXT_PATH', 'contextPath');
    </file>
 * </example>
 *
 */
// @formatter:on
/*@ngInject*/
export default function recordDetailPathFilter() {
    return (record) => {
        if (!record.id) {
            throw new Error('Missing record id');
        }
        return getRecordPath(getRecordUrlId(record));
    }
}

recordDetailPathFilter.filterName = 'kpRecordDetailPath';